import React from "react";
import MenuContextProvider from "@/context/menu-context";
import SearchContextProvider from "@/context/search-context";
import Layout from "@/components/layout";
import Menu from "@/components/header-one";
import Footer from "@/components/footer";
import ContentCultura from "@/components/ContentCultura";
import CalendarioEscolar from "@/components/CalendarioEscolar";
import SliderCalendarioEscolar from '@/components/Slider';
import SEO from '../components/seo'

const Cultura = () => {
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout>
          <SEO
            title="Cultura - Aprender para se integrar: cultura que une gerações"
            pathname="/"
          />
          <Menu />
          <ContentCultura />
          <CalendarioEscolar />
          <SliderCalendarioEscolar />
          <Footer /> 
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  )
}

export default Cultura;
